window.dataLayer = window.dataLayer || [];

import { clickHandler, determineActionText } from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'socialShare_tracking';
const actionPropTitle = 'socialShare_action';
const labelPropTitle = 'socialShare_label';

const elements = [...document.querySelectorAll('.js-social-share-link-ga')];

function bindEventListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click`,
      label: `${determineActionText(el)}`,
    }),
  );
}

function init() {
  if (!elements.length) {
    return;
  }

  elements.forEach(bindEventListener);
}

export default init;
